import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../assets/images/Notification/call-noti-close-icon.svg'


const _hoisted_1 = { class: "d-flex align-items-center justify-content-between p-3 mb-0 fw-bold add-member-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "axxess-logo-bg" }, null, -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "chat-history-box m-3"
}
const _hoisted_4 = { class: "form-group form-check custom-checkbox mb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "chat-history"
}, " Share entire chat history", -1 /* HOISTED */)
const _hoisted_6 = { class: "d-flex justify-content-center pb-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TagsInput = _resolveComponent("TagsInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.isGroupConversation ? "Add Member" : "Start a group chat") + " ", 1 /* TEXT */),
      _createElementVNode("img", {
        class: "cursor-pointer",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
      })
    ]),
    _createVNode(_component_TagsInput, {
      class: "w-100 p-3",
      getData: _ctx.getUsersList,
      tags: _ctx.users,
      onUpdateTags: _ctx.updateTags,
      placeholder: "Enter name",
      "is-focus": true,
      "is-for-messaging": true,
      "show-pill": false,
      classes: "w-100 grey-input",
      focusOnInput: "true"
    }, null, 8 /* PROPS */, ["getData", "tags", "onUpdateTags"]),
    _hoisted_2,
    (_ctx.isGroupConversation && !_ctx.isDraftConversation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.includeChatHistory) = $event)),
              id: "chat-history"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, _ctx.includeChatHistory]
            ]),
            _hoisted_5
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("footer", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary me-2 w-30",
        disabled: _ctx.isLoading,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
      }, " Cancel ", 8 /* PROPS */, _hoisted_7),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary border border-primary w-30",
        disabled: _ctx.isLoading,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.add()))
      }, _toDisplayString(_ctx.isGroupConversation ? "Add" : "Create"), 9 /* TEXT, PROPS */, _hoisted_8)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}